import api from '@/services/api'

export default {
  login(userCode, password) {
    return api.post('/admin/users/login', { userCode, password })
  },

  getData() {
    return api.get('/companies')
  },

  getStats() {
    return api.get('/admin/users/stats')
  },

  getList(page, term) {
    return api.get(`/users/list?page=${page}&term=${term}`)
  },

  blockCustomer(id) {
    return api.put(`/users/block/${id}`)
  },

  unblockCustomer(id) {
    return api.put(`/users/unblock/${id}`)
  },

  recoverPassword(userId, email) {
    return api.post(`/users/recover-password/${userId}`, { email });
  },
}